import Vue from 'vue'
import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

// Global components
import AppTemplate from './components/AppTemplate.vue'
Vue.component('app-template', AppTemplate)

import AdminTemplate from './components/AdminTemplate.vue'
Vue.component('admin-template', AdminTemplate)

import TechTemplate from './components/TechTemplate.vue'
Vue.component('tech-template', TechTemplate)

import MobileTemplate from './views/Mobile/Components/MobileTemplate.vue'
Vue.component('mobile-template', MobileTemplate)

import InputFile from './components/InputFile.vue'
Vue.component('input-file', InputFile)

import InputSignature from './components/InputSignature.vue'
Vue.component('input-signature', InputSignature)

import InputTel from './components/InputTel.vue'
Vue.component('input-tel', InputTel)

import ChartWrapper from './components/ChartWrapper.vue'
Vue.component('chart-wrapper', ChartWrapper)

// Packages
// Toastification
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
Vue.use(Toast, {});

// Input tel
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

// Modal
import VModal from 'vue-js-modal/dist/index.nocss.js'
import 'vue-js-modal/dist/styles.css'
Vue.use(VModal)

// Signature pad
import VueSignaturePad from 'vue-signature-pad';
import "vue-wysiwyg/dist/vueWysiwyg.css";
Vue.use(VueSignaturePad);

// WYSIWYG editor
import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {
    maxHeight: "500px"
});

import VueEasytable from 'vue-easytable'
import 'vue-easytable/libs/theme-default/index.css'
Vue.use(VueEasytable)

// Services
import apiService from './services/api.service'
Vue.prototype.$request = apiService

import env from './services/env.service'
Vue.prototype.$env = env

import EventHub from '@/eventHub';
Vue.prototype.$eventHub = EventHub

import inpError from '@/services/inpError.service';
Vue.prototype.$inpError = inpError

// Initialisation de l'application
let init = async () => {
    // Récupération du compte utilisateur
    let token = null
    if (sessionStorage.getItem('auth-token')) {
        token = sessionStorage.getItem('auth-token')
    } else if (localStorage.getItem('auth-token')) {
        token = localStorage.getItem('auth-token')
    }
    if (token) {
        let account = await apiService.get('/auth/me')
        Vue.prototype.$account = account
        
        let currentUrlPath = window.location.pathname
        // if (account.account.super_admin == 1 && currentUrlPath.startsWith('/app') && !currentUrlPath.startsWith('/admin') && !currentUrlPath.startsWith('/app/auth')) {
        //     router.push({ name: 'AdminDashboard' })
        // }
        if (account.account.super_admin == 0 && account.account.societe.is_init == 0 && router.currentRoute.name !== 'Welcome') {
            router.push({ name: 'Welcome' })
        }
    }

    new Vue({
        router,
        render: h => h(App)
    }).$mount('#app')
}
init()